import EventEmitter from "events";

import AuthApi from "../api/auth";

const loginEvent = "loginEvent";
const env = process.env.NODE_ENV;
const cookieSecure = process.env.VUE_APP_COOKIE_SECURE == "true" ? true : null;
const cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;
const tokenKey = process.env.VUE_APP_COOKIE_AUTH;
const twoFactKey = process.env.VUE_APP_TWO_FACT;
const tokenExpiryKey = process.env.VUE_APP_COOKIE_AUTH_TE;
const tokenUserInfo = process.env.VUE_APP_COOKIE_AUTH_UI;

class AuthService extends EventEmitter {

  async login(body, customState) {
    let response = await AuthApi.login(body, customState);

    if (!response.data.error) {
      this.setLogin(response.data);
    }
  }

  async loginForPerson(body, customState) {
    let response = await AuthApi.loginForPerson(body, customState);

    if (!response.data.error) {
      this.setLogin(response.data);
    }
  }

  async loginForStudent(body, customState) {
    let response = await AuthApi.loginForStudent(body, customState);

    if (!response.data.error) {
      this.setToken(response.data);

      this.emit(loginEvent, {
        loggedIn: true,
        ...response.data
      });
    }
  }

  async loginForTumer(body, customState) {
    let response = await AuthApi.loginForTumer(body, customState);

    if (!response.data.error) {
      this.setToken(response.data);

      this.emit(loginEvent, {
        loggedIn: true,
        ...response.data
      });
    }
  }

  async loginForGraduate(body, customState) {
    let response = await AuthApi.loginForGraduate(body, customState);

    if (!response.data.error) {
      this.setToken(response.data);

      this.emit(loginEvent, {
        loggedIn: true,
        ...response.data
      });
    }
  }

  clearInfo(data) {
    $cookies.set(
      tokenUserInfo,
      data,
      "5d",
      null,
      cookieDomain,
      cookieSecure
    );
  }

  setLogin(authResult) {
    $cookies.set(
      twoFactKey,
      true,
      "5d",
      null,
      cookieDomain,
      cookieSecure
    );
    //
    this.emit(loginEvent, {
      loggedIn: true,
      ...authResult
    });
  }

  setToken(authResult){
    $cookies.remove(twoFactKey, "/", cookieDomain);

    var token = authResult.Token;

    $cookies.set(
      tokenKey,
      token,
      "5d",
      null,
      cookieDomain,
      cookieSecure
    );

    $cookies.remove(tokenUserInfo, "/", cookieDomain);
  }

  twoFactComplete(){ 
    $cookies.remove(twoFactKey, "/", cookieDomain);
  }

  hideLogin(user) {
    $cookies.set(
      tokenKey,
      user.AccessToken,
      "5d",
      null,
      cookieDomain,
      cookieSecure
    );

    delete user.AccessToken;
    delete user.GatewayUrl;

    $cookies.set(
      tokenUserInfo,
      user,
      "5d",
      null,
      cookieDomain,
      cookieSecure
    );
  }

  renewTokens() {
    if (this.isAuthenticated()) {
      this.emit(loginEvent, {
        loggedIn: true,
      });
    }
  }

  logOut() {
    $cookies.remove(tokenKey, "/", cookieDomain);
    $cookies.remove(tokenUserInfo, "/", cookieDomain);
    $cookies.remove(twoFactKey, "/", cookieDomain);
    this.emit(loginEvent, { loggedIn: false });
  }

  getToken() {
    return $cookies.get(tokenKey);
  }
  
  needSmsVerify(){
      return $cookies.get(twoFactKey);
  }

  isAuthenticated() {
    const token = $cookies.get(tokenKey);
    const two = $cookies.get(twoFactKey);
    
    return (
      token && !two
    );
  }
 
  isFullAuthenticated() {
    const token = $cookies.get(tokenKey);
    const userInfo = $cookies.get(tokenUserInfo);
    const two = $cookies.get(twoFactKey);

    return (
      token && userInfo && !two
    );
  }

  hasUserRole(role) {
    if (role == "*") return true;
    if (role == '~') return this.isAuthenticated();

    const localData = $cookies.get(tokenUserInfo);
    if (!localData) return false;

    const userInfo = $cookies.get(tokenUserInfo);
    return userInfo &&
      userInfo.Roles &&
      userInfo.Roles.some(x => x.includes(role))
      ? true
      : false;
  }

  can(controller, method, level) {
    let canAccess = false;
    const localData = $cookies.get(tokenUserInfo);

    if (localData && this.isAuthenticated()) {
      const userInfo = $cookies.get(tokenUserInfo);
      if (userInfo.Roles && userInfo.Roles.length >= 0) {
        userInfo.Roles.forEach(el => {
          const spArray = el.toString().split(".");
          if (spArray.length >= 3) {
            const _controller = spArray[spArray.length - 3];
            const _method = spArray[spArray.length - 2];
            const _level = spArray[spArray.length - 1];

            if (
              controller.toLowerCase() == _controller.toLowerCase() &&
              method.toLowerCase() == _method.toLowerCase() &&
              level.toLowerCase() == _level.toLowerCase()
            )
              return (canAccess = true);
          }
        });
      }
    }
    return canAccess;
  }
}

export default new AuthService();
